import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import { initializeAuth } from './lib/mobile-auth';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

defineCustomElements(window);

initializeAuth().then(
    () => {
        if (window.location.pathname == '/auth') {
            console.log('authenticating...');
            ReactDOM.render(
                <React.StrictMode>
                    <h3>Authenticating...</h3>
                </React.StrictMode>,
                document.getElementById('root')
            );
        } else {
            console.log('Launching app...');
            ReactDOM.render(
                <React.StrictMode>
                    <App />
                </React.StrictMode>,
                document.getElementById('root')
            );
        }
    },

    (e) => console.log('Could not login', e)
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
